import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allEmailSettings } from 'app/mocks/data/settings/email'

import { api } from 'app/utils/constants'

import { EmailSettingsPayload } from 'app/types/settings/email'

export const updateEmailSettings = http.patch(
    `${process.env.REACT_APP_API_ADDRESS}/${api.settings.email.DETAILS}`,
    async ({ request, params }) => {
        const { id } = params
        const payload = await request.json()
        const payloadParsed = EmailSettingsPayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return new HttpResponse(null, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        const emailSettingsFound = allEmailSettings.find(
            (emailSettings) => emailSettings.id.toString() === id,
        )

        if (!emailSettingsFound) {
            return new HttpResponse(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        const emailSettingsUpdated = {
            ...payloadParsed.data,
        }

        return HttpResponse.json(emailSettingsUpdated)
    },
)
